import { useMemo } from "react";

import { DynamicFormV2Palette, useTheme } from "@mui/material";
import { isDullMode } from "@simplyk/common";

/**
 * This hook is meant to be used by 1-off components that need to be aware of the theme.
 * For design-system components, please add component tokens directly in the theme instead (via `assign<Component>ComponentTokens`)
 */
export const useDynamicThemeAwareVariables = <T>(
  callback: (input: { formsPalette: DynamicFormV2Palette["forms"]; mode: "light" | "dark"; isDullMode: boolean }) => T
) => {
  const theme = useTheme();

  if (!theme.palette.metadata) {
    throw new Error("There is no dynamic theme declared");
  }

  const mode = theme.palette.metadata.mode;
  const isDull = isDullMode(theme.palette.metadata.baseColor);
  const formsPalette = theme.palette.forms;

  return useMemo(() => callback({ formsPalette, mode, isDullMode: isDull }), [formsPalette, mode, isDull, callback]);
};
